import { Component } from '@angular/core';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { LogRocketService } from './services/log-rocket.service';
import { PwaService } from './services/pwa.service';

@Component({
    selector: 'is-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: {
                position: 'above',
                showDelay: 1000,
                hideDelay: 500,
                touchendHideDelay: 500,
            } }],
    standalone: false
})
export class AppComponent {
  /* eslint @typescript-eslint/no-unused-vars: "off" */
  constructor(
    pwa: PwaService,
    logRocket: LogRocketService,
  ) {}
}
